import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { WorkspaceService } from '../../workspace/workspace.service';
import { AdminRouteData, normalizeBreadcrumbData } from './admin-route-data';

/**
 * Resolves admin/userSettings breadcrumbs from route `data.breadcrumb`
 * and publishes them to the legacy header via setTabActive (breadcrumb-only).
 */
@Injectable()
export class AdminBreadcrumbService {
  constructor(private workspaceService: WorkspaceService) {}

  /**
   * Walks the activated route tree from the admin shell downward and collects
   * every `data.breadcrumb` segment in order (supports nested child routes).
   */
  resolveLabels(shellRoute: ActivatedRoute): string[] {
    const labels: string[] = [];
    this.collectFromRoute(shellRoute, labels);
    return labels;
  }

  /** Bridge to HeaderComponent — no `link` to avoid workspace navigation side effects. */
  publishToHeader(labels: string[]): void {
    if (!labels.length) {
      return;
    }
    this.workspaceService.setTabActive.next({
      label: labels[labels.length - 1],
      breadcrumbLabels: labels,
    });
  }

  private collectFromRoute(route: ActivatedRoute, labels: string[]): void {
    const data = route.snapshot.data as AdminRouteData;
    labels.push(...normalizeBreadcrumbData(data?.breadcrumb));

    const child = route.firstChild;
    if (child) {
      this.collectFromRoute(child, labels);
    }
  }
}
